import List from 'layouts/order/List.js';
import OrderDetails from 'layouts/order/OrderDetails.js';
import ProtectedRoute from "routes/protectedRoutes.js";

const OrderRoutes = [

    {
      route: "/order/list/:pageNo",
      key: "manage-orders",
      component: <ProtectedRoute check="logout"><List /></ProtectedRoute>
    },
    {
      route: "/order/details/:orderID",
      key: "order-details",
      component: <ProtectedRoute check="logout"><OrderDetails /></ProtectedRoute>
    },
    

  ];

export default OrderRoutes;
 